// Angular
import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {NgClass} from '@angular/common';
// App
import {BackdropService} from '@app/core/services/backdrop.service';


@Component({
  selector: 'app-global-backdrop',
  imports: [NgClass],
  templateUrl: './global-backdrop.component.html',
  styleUrl: './global-backdrop.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GlobalBackdropComponent {
  readonly backdrop = inject(BackdropService);
}
